export class AuthTenantSelectionFailedMessage {
}